import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import Amplitude from 'utils/amplitude';
import Modal from 'utils/packages/Modal';
import Share from 'utils/packages/rnShare';
import { createInviteMessage } from '../utils/inviteMessage';
const canUseWebShare = () => typeof window !== 'undefined' && !!window.navigator?.share;
const copyToClipboard = async (text) => {
    try {
        await window.navigator.clipboard.writeText(text);
        return true;
    }
    catch {
        return false;
    }
};
/**
 * Shares the user's referral link with the Web Share API. Browsers without it
 * (e.g. Firefox on desktop), or that refuse to share for a reason other than
 * the user closing the sheet, get the message copied to the clipboard instead.
 * If the browser refuses that too, the link is shown to copy by hand.
 */
const useInviteFriends = () => {
    const name = useAppSelector((store) => store.user.user.firstName);
    const userUrl = useAppSelector((store) => store.user.user.userUrl);
    const givePremiumTrialDays = useAppSelector((store) => store.referrals.activeProgram?.givePremiumTrialDays);
    return useCallback(() => {
        const message = `${createInviteMessage(name, givePremiumTrialDays)} ${userUrl}`;
        Amplitude.logEvent('Invite.OpenLink', { type: 'default', screen: 'web' });
        const copyOrShowLink = () => copyToClipboard(message).then((copied) => {
            if (copied) {
                Modal.showError('Paste it into a message to send it to your friends.', undefined, 'Invite link copied', 'Okay');
            }
            else {
                Modal.showError(`Send this link to your friends: ${userUrl}`, undefined, 'Invite friends', 'Okay');
            }
        });
        if (!canUseWebShare()) {
            copyOrShowLink();
            return;
        }
        Share.open({ message }).catch((error) => {
            if (error instanceof Error && error.name === 'AbortError')
                return;
            copyOrShowLink();
        });
    }, [givePremiumTrialDays, name, userUrl]);
};
export default useInviteFriends;
